module.exports = __webpack_public_path__ + "img/mapa-ciafarma.87231dc7.png";